import { createSelector } from '@reduxjs/toolkit';

import isUserAgencyPrimarySelector from 'store/selectors/userSelectors/isUserAgencyPrimarySelector';
import isUserEssentialPrimarySelector from 'store/selectors/userSelectors/isUserEssentialPrimarySelector';
import isUserPremiumPrimarySelector from 'store/selectors/userSelectors/isUserPremiumPrimarySelector';

const isUserPrimarySelector = createSelector(
  isUserEssentialPrimarySelector,
  isUserPremiumPrimarySelector,
  isUserAgencyPrimarySelector,
  (isUserEssentialPrimary, isUserPremiumPrimary, isUserAgencyPrimary) => {
    return isUserEssentialPrimary || isUserPremiumPrimary || isUserAgencyPrimary;
  },
);

export default isUserPrimarySelector;
